import React, { FC } from 'react';
import Routes from './Components/Routes/Routes';

// import med from 'Assets/js/jquery-plugin-collection.js'
const App: FC<any> = () => {
	return (
		<>
			<Routes />
		</>
	);
};

export default App;
